import axios from "axios";
import accountBalance from "../../models/gestionEmpleados/empleados/accountBalance";
import accountBalanceHistory from "../../models/gestionEmpleados/empleados/accountBalanceHistory";
import { getConfig } from "@/config";

class service {
  constructor() {
    this._config = null;
  }

  get config() {
    if (!this._config) {
      const cfg = getConfig();
      if (!cfg) throw new Error("Config not loaded");
      this._config = cfg;
    }
    return this._config;
  }

  getAccountBalances() {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const empId = localStorage.getItem("empId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/empleadostopes/${empId}`, { headers })
      .then(({ data }) => {
        return data.map((item) => {
          return accountBalance.fromJson(item);
        });
      });
  }
  getAccountBalanceHistory(data) {
    let token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const empId = localStorage.getItem("empId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    return axios
      .get(`${url}/empleadostopes/movim/${empId}&${data.conceptId}`, {
        headers,
      })
      .then(({ data }) => {
        return data.map((item) => {
          return accountBalanceHistory.fromJson(item);
        });
      });
  }

  new(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      empId: parseInt(localStorage.getItem("empId"), 10),
      aplicaEn: data.appliesIn,
      conceptos: data.concepts,
    };
    return axios.post(`${url}/empleadostopes`, payload, { headers });
  }
  newMovim(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;

    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      empId: parseInt(localStorage.getItem("empId"), 10),
      conceptoId: data.conceptId,
      cantidad: data.amount,
      operId: parseInt(localStorage.getItem("operId"), 10),
    };
    return axios.post(`${url}/empleadostopes/movim`, payload, { headers });
  }

  delete = (data) => {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    let headers = {
      Authorization: `Bearer ${token}`,
    };

    const empId = localStorage.getItem("empId");
    let conceptoId = data.conceptoId;

    return axios.delete(`${url}/empleadostopes/${empId}&${conceptoId}`, {
      headers,
    });
  };

  edit(data) {
    const token = localStorage.getItem("token");
    const url = this.config.apiUrl;
    const empId = localStorage.getItem("empId");
    let headers = {
      Authorization: `Bearer ${token}`,
    };
    let payload = {
      cantidad: Number(data.amount),
    };

    return axios
      .patch(`${url}/empleadostopes/${empId}&${data.conceptId}`, payload, {
        headers,
      })
      .then(() => {});
  }
}
export default service;
